import React, { useCallback } from 'react'
import { ActionButton } from '@fluentui/react/lib/Button'
import { useShowToastDidCopyLinkToClipboard } from '../../hooks/clipboardHooks'
import { copyToClipboard } from '../../common/src/helpers/clipboardUtils'
import { TooltipHost } from '@/components/tooltip/TooltipHost'
import { useTranslation } from 'react-i18next'

const iconStyles = {
  root: {
    fontSize: 16,
  },
}

const tooltipHostStyles = {
  root: {
    display: 'block',
  },
}

const buttonStyles = {
  root: {
    height: 32,
  },
}

export const useCopyColumn = () => {
  const showToastDidCopyLinkToClipboard = useShowToastDidCopyLinkToClipboard()
  const copyLink = useCallback(
    link => {
      copyToClipboard(link)
      showToastDidCopyLinkToClipboard()
    },
    [showToastDidCopyLinkToClipboard]
  )
  const { t } = useTranslation()

  return {
    key: 'copyLink',
    name: null,
    isIconOnly: true,
    minWidth: 30,
    onRender: element => {
      const onCopyLink = () => copyLink(element.url || element.link)
      return (
        <TooltipHost content={t('item.file.copy_link')} styles={tooltipHostStyles}>
          <ActionButton
            styles={buttonStyles}
            onClick={onCopyLink}
            iconProps={{ iconName: 'Copy', styles: iconStyles }}
          />
        </TooltipHost>
      )
    },
  }
}
